<template>
  <div class="declare" ref="declare">
    <topnav title=""追梦计划"创业大赛报名" />
    <div class="main">
      <tabstep :activeIndex="activeIndex" :tipsTitle="tipsTitle" @tipsClick="tipsClick" />
      <tabtitle :title="ActiveTitle" />
      <div v-show="activeIndex==0" class="my-form">
        <div class="input-group">
          <label for="username">
            <span>*</span>姓名：
          </label>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="请输入姓名"
            v-model="formData1.username"
          />
        </div>
        <div class="input-group">
          <label for="sex">
            <span>*</span>性别：
          </label>
          <div class="radio">
            <van-radio-group v-model="formData1.sex" direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="input-group">
          <label for="nation">
            <span>*</span>民族：
          </label>
          <input
            type="text"
            id="nation"
            name="nation"
            placeholder="请输入民族"
            v-model="formData1.nation"
          />
        </div>
        <div class="input-group">
          <label for="birth">
            <span>*</span>出生年月：
          </label>
          <div class="date" @click="showDate">{{formData1.birth}}</div>
        </div>
        <div class="input-group">
          <label for="face">
            <span>*</span>政治面貌：
          </label>
          <input type="text" id="face" name="face" placeholder="请输入政治面貌" v-model="formData1.face" />
        </div>
        <div class="input-group">
          <label for="degree">
            <span>*</span>学历学位：
          </label>
          <input
            type="text"
            id="degree"
            name="degree"
            placeholder="请输入学历学位"
            v-model="formData1.degree"
          />
        </div>
        <div class="input-group">
          <label for="mobile">
            <span>*</span>联系电话：
          </label>
          <input
            type="text"
            id="mobile"
            name="mobile"
            placeholder="请输入联系电话"
            v-model="formData1.mobile"
          />
        </div>
        <div class="input-group">
          <label for="idcard">
            <span>*</span>身份证号：
          </label>
          <input
            type="text"
            id="idcard"
            name="idcard"
            placeholder="请输入身份证号"
            v-model="formData1.idcard"
          />
        </div>
        <div class="input-group">
          <label for="university">
            <span>*</span>所在院校：
          </label>
          <input
            type="text"
            id="university"
            name="university"
            placeholder="请输入所在院校"
            v-model="formData1.university"
          />
        </div>
        <div class="input-group">
          <label for="major">
            <span>*</span>所学专业：
          </label>
          <input
            type="text"
            id="major"
            name="major"
            placeholder="请输入所学专业"
            v-model="formData1.major"
          />
        </div>
        <div class="input-group">
          <van-button type="primary" color="#2eaeb4" class="btn" @click="goSetp(1)">下一步</van-button>
        </div>
      </div>
      <div v-show="activeIndex==1" class="my-form">
        <div class="input-group tips">
          <label for>团队人数：</label>
          <input type="number" placeholder="请输入团队人数" v-model="memberNumber" />
          <div class="member-tips">PS:填写团队人数，下面自动生成团队成员表格</div>
        </div>
        <div class="member-box">
          <div class="member-item" v-for="(item, index) in memberList" :key="index">
            <p class="index">成员{{index+1}}</p>
            <div class="member-form">
              <div class="member-input-group">
                <label for>姓名：</label>
                <input type="text" placeholder="请输入成员姓名" v-model="item.username" />
              </div>
              <div class="member-input-group">
                <label for>性别：</label>
                <div class="radio">
                  <van-radio-group direction="horizontal" v-model="item.sex">
                    <van-radio name="男">男</van-radio>
                    <van-radio name="女">女</van-radio>
                  </van-radio-group>
                </div>
              </div>
              <div class="member-input-group">
                <label for>年龄：</label>
                <input type="number" placeholder="请输入年龄" v-model="item.age" />
              </div>
              <div class="member-input-group">
                <label for>所在院校：</label>
                <input type="text" placeholder="请输入所在院校" v-model="item.university" />
              </div>
              <div class="member-input-group">
                <label for>联系电话：</label>
                <input type="text" placeholder="请输入联系电话" v-model="item.mobile" />
              </div>
              <div class="member-input-group">
                <label for>备注：</label>
                <input type="text" placeholder="请输入备注" v-model="item.remarks" />
              </div>
            </div>
          </div>
        </div>
        <div class="input-group">
          <van-button type="primary" color="#2eaeb4" class="btn" @click="goSetp(2)">下一步</van-button>
        </div>
      </div>
      <div v-show="activeIndex==2" class="my-form">
        <div class="input-group">
          <label for="project">
            <span>*</span>项目名称：
          </label>
          <input
            type="text"
            id="project"
            name="project"
            placeholder="请输入项目名称"
            v-model="formData3.project"
          />
        </div>
        <div class="input-group textarea">
          <label for="introduction">
            <span>*</span>项目简介：
          </label>
          <textarea
            id="introduction"
            name="introduction"
            placeholder="请输入项目简介"
            v-model="formData3.introduction"
          ></textarea>
        </div>
        <div class="input-group textarea">
          <label for="experience">
            <span style="opacity: 0">*</span>创业经历：
          </label>
          <textarea
            id="experience"
            name="experience"
            placeholder="请输入创业经历"
            v-model="formData3.experience"
          ></textarea>
        </div>
        <div class="input-group">
          <label for="experience">
            <span>*</span>项目计划书：
          </label>
          <div class="upload-box">
            <template v-if="fileName1 == ''">
              <i class="upload-icon"></i>
              <span class="upload-tips">只能上传doc/docx/pdf文件，且不超过5M</span>
            </template>
            <span v-else class="file-name">{{fileName1}}</span>
            <input
              type="file"
              class="upload-file"
              accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              @change="uploadFile($event,1)"
            />
          </div>
        </div>
        <div class="input-group">
          <label for="experience">
            <span style="opacity: 0">*</span>项目视频：
          </label>
          <div class="upload-box">
            <template v-if="fileName2 == ''">
              <i class="upload-icon"></i>
              <span class="upload-tips">只能上传mp4文件，且不超过20M</span>
            </template>
            <div v-else class="file-name">{{fileName2}}</div>
            <input
              type="file"
              class="upload-file"
              accept="audio/mp4, video/mp4"
              @change="uploadFile($event,2)"
            />
          </div>
        </div>
        <div class="input-group">
          <label for="experience">
            <span style="opacity: 0">*</span>项目图片：
          </label>
          <div class="upload-box">
            <template v-if="formData3.img == ''">
              <i class="upload-icon"></i>
              <span class="upload-tips">只能上传png/jpg文件，且不超过10M</span>
            </template>
            <van-image v-else width="100" height="auto" :src="formDataImg" lazy-load />
            <input type="file" class="upload-file" accept="image/*" @change="uploadFile($event,3)" />
          </div>
        </div>
        <div class="input-group promise">
          <van-checkbox
            v-model="formData3.promise"
            shape="square"
            icon-size="14px"
            checked-color="#2fafb4"
            class="text"
          >本人（团队）承诺：以上所述属实，若有任何虚假信息，愿承担相应法律责任。</van-checkbox>
        </div>
        <div class="input-group">
          <van-button type="primary" color="#2eaeb4" class="btn" @click="goSetp(3)">提交</van-button>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirmDate"
        @cancel="hideDate"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
import Topnav from "@/components/Topnav";
import Tabtitle from "@/components/Tabtitle";
import Tabstep from "@/components/Tabstep";
import { upload } from "@/api/common.js";
import { addEditSignup } from "@/api/declare.js";
import { Notify, Toast } from "vant";
import axios from "axios";

export default {
  name: "Declare",
  components: {
    Topnav,
    Tabtitle,
    Tabstep
  },
  data() {
    return {
      activeIndex: 0,
      titleArray: ["基本信息", "团队信息", "项目信息"],
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2020, 11, 1),
      formData1: {
        username: "",
        sex: "",
        nation: "",
        birth: "",
        face: "",
        degree: "",
        mobile: "",
        idcard: "",
        university: "",
        major: ""
      },
      formData2: [],
      formData3: {
        project: "",
        introduction: "",
        experience: "",
        file: "",
        video: "",
        img: "",
        promise: true
      },
      fileName1: "",
      fileName2: "",
      formErrorTips1: [
        "姓名不能为空",
        "性别未选择",
        "民族不能为空",
        "出生年月不能为空",
        "政治面貌不能为空",
        "学历学位不能为空",
        "联系电话不能为空",
        "身份正号不能为空",
        "所在院校不能为空",
        "所学专业不能为空"
      ],
      formErrorTips3: [
        "项目名称不能为空",
        "项目简介不能为空",
        "1",
        "项目计划书未上传",
        "1",
        "1",
        "承诺协议未勾选"
      ],
      showPicker: false,
      gotop: false,
      memberNumber: 0,
      operation: "add"
    };
  },
  computed: {
    tipsTitle() {
      return this.activeIndex == 1 ? "如果是个人参赛，可不填写" : "参赛须知";
    },
    ActiveTitle() {
      return this.titleArray[this.activeIndex];
    },
    memberList() {
      if (window.localStorage.getItem("formData2")) {
        return this.formData2;
      }
      for (let i = 0; i < this.memberNumber; i++) {
        this.formData2.push({
          username: "",
          sex: "",
          age: "",
          university: "",
          mobile: "",
          remarks: ""
        });
      }
      return this.formData2;
    },
    formatterDate() {
      let tempDate = "";
      if (this.formData1.birth == "") {
        return "";
      } else {
        return (tempDate = this.dateFormat("YYYY-mm-dd", this.formData1.birth));
      }
    },
    formDataImg() {
      if (this.formData3.img == "") {
        return "";
      } else {
        return this.$url + this.formData3.img;
      }
    }
  },
  watch: {
    memberNumber(val) {
      if (val == "" || val == 0) {
        // this.memberNumber = 0;
        return false;
      } else if (val >= 20) {
        this.memberNumber = 20;
      }
      let isAdd = this.memberNumber - this.formData2.length < 0 ? false : true;
      if (isAdd) {
        for (let i = 0; i < this.memberNumber - this.formData2.length; i++) {
          this.formData2.push({
            username: "",
            sex: "",
            age: "",
            university: "",
            mobile: "",
            remarks: ""
          });
        }
      } else {
        this.formData2 = [];
        for (let i = 0; i < this.memberNumber; i++) {
          this.formData2.push({
            username: "",
            sex: "",
            age: "",
            university: "",
            mobile: "",
            remarks: ""
          });
        }
      }
    }
  },
  created() {
    let formData1 = window.localStorage.getItem("formData1");
    let formData2 = window.localStorage.getItem("formData2");
    if (formData1) {
      for (let k in this.formData1) {
        this.formData1[k] = JSON.parse(formData1)[k];
      }
    }
    if (formData2) {
      formData2 = JSON.parse(formData2);
      this.memberNumber = formData2.length;
      formData2.forEach((item, index) => {
        this.formData2[index] = Object.assign({}, item);
      });
    }
  },
  mounted() {
    // this.activeIndex = 2;
  },
  methods: {
    getInfo() {
      let tempFormData = {
        zm_id: this.formData1.zm_id
      };
      getZmInfo(tempFormData)
        .then(res => {
          for (let k in res.data) {
            this.formData1[k] = res.data[k];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDate() {
      this.showPicker = true;
    },
    hideDate() {
      this.showPicker = false;
    },
    confirmDate(e) {
      this.formData1.birth = this.dateFormat("YYYY-mm-dd", e);
      this.showPicker = false;
    },
    tipsClick() {
      this.$router.push({
        name: "Agreement"
      });
    },
    goSetp(index) {
      switch (index) {
        case 1:
          var arr = Object.keys(this.formData1);
          for (let i = 0; i < arr.length; i++) {
            if (this.formData1[arr[i]] == "") {
              Toast({
                message: this.formErrorTips1[i],
                position: "bottom"
              });
              return false;
            } else if (arr[i] == "idcard") {
              if (
                !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
                  this.formData1[arr[i]]
                )
              ) {
                Toast({
                  message: "身份证号码格式不对",
                  position: "bottom"
                });
                return false;
              }
            }
          }
          window.localStorage.setItem(
            "formData1",
            JSON.stringify(this.formData1)
          );
          this.activeIndex = index;
          this.scrollTop();
          break;
        case 2:
          let tempArr = [];
          let tempArr2 = [];
          window.localStorage.setItem(
            "formData2",
            JSON.stringify(this.formData2)
          );
          if (this.formData2.length < 1) {
            this.formData2 = "";
          } else {
            for (let i = 0; i < this.formData2.length; i++) {
              Object.keys(this.formData2[i]).forEach(key => {
                tempArr2.push(this.formData2[i][key]);
              });
              tempArr.push(tempArr2);
              tempArr2 = [];
            }
            this.formData2 = JSON.stringify(tempArr);
          }
          this.activeIndex = index;
          this.scrollTop();
          break;
        case 3:
          this.formData1.birth = this.dateFormat(
            "YYYY-mm-dd",
            this.formData1.birth
          );
          var arr = Object.keys(this.formData3);
          let tempFormData = {};
          for (let i = 0; i < arr.length; i++) {
            if (this.formData3[arr[i]] == "") {
              if (
                arr[i] == "experience" ||
                arr[i] == "video" ||
                arr[i] == "img"
              ) {
              } else {
                Toast({
                  message: this.formErrorTips3[i],
                  position: "bottom"
                });
                return false;
              }
            }
          }
          tempFormData = Object.assign(
            {},
            this.formData1,
            { member: this.formData2 },
            this.formData3
          );
          tempFormData.operation = this.operation;
          tempFormData.uid = JSON.parse(window.localStorage.getItem("user")).id;
          tempFormData.promise = tempFormData.promise ? 1 : 0;
          addEditSignup(tempFormData)
            .then(res => {
              window.localStorage.removeItem("formData1");
              window.localStorage.removeItem("formData2");
              Notify({
                type: "success",
                message: "报名成功",
                onClose: () => {
                  this.$router.push({
                    name: "My"
                  });
                }
              });
            })
            .catch(err => {
              console.error(err);
            });
          break;
      }
    },
    uploadFile(event, index) {
      let file = event.target.files[0];
      switch (index) {
        case 1:
          var name = file.name;
          var fileName = name
            .substring(name.lastIndexOf(".") + 1)
            .toLowerCase();
          var form = new FormData();
          if (fileName != "doc" && fileName != "docx" && fileName != "pdf") {
            Toast({
              message: "文件上传格式不对",
              position: "bottom"
            });
            return;
          }
          var size = file.size / 1024;
          if (size > 5000) {
            Toast({
              message: "附件不能大于5M",
              position: "bottom"
            });
            return;
          }
          this.fileName1 = name;
          form.append("type", 1);
          form.append("file", file);
          axios({
            method: "post",
            url: "http://whqncy.com/api/upload",
            data: form,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
            .then(res => {
              this.formData3.file = res.data.data;
            })
            .catch(err => {
              console.log(err);
            });
          break;
        case 2:
          var name = file.name;
          var fileName = name
            .substring(name.lastIndexOf(".") + 1)
            .toLowerCase();
          var form = new FormData();
          this.fileName2 = name;
          if (fileName != "mp4") {
            Toast({
              message: "文件上传格式不对",
              position: "bottom"
            });
            return;
          }
          var size = file.size / 1024;
          if (size > 20000) {
            Toast({
              message: "附件不能大于20M",
              position: "bottom"
            });
            return;
          }

          form.append("type", 2);
          form.append("video", file);
          axios({
            method: "post",
            url: "http://whqncy.com/api/upload",
            data: form,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
            .then(res => {
              this.formData3.video = res.data.data;
            })
            .catch(err => {
              console.log(err);
            });
          break;
        case 3:
          var name = file.name;
          var fileName = name
            .substring(name.lastIndexOf(".") + 1)
            .toLowerCase();
          var form = new FormData();
          if (fileName != "png" && fileName != "jpg") {
            Toast({
              message: "文件上传格式不对",
              position: "bottom"
            });
            return;
          }
          var size = file.size / 1024;
          if (size > 10240) {
            Toast({
              message: "附件不能大于10M",
              position: "bottom"
            });
            return;
          }

          form.append("type", 3);
          form.append("img", file);
          axios({
            method: "post",
            url: "http://whqncy.com/api/upload",
            data: form,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
            .then(res => {
              this.formData3.img = res.data.data;
            })
            .catch(err => {
              console.log(err);
            });
          break;
      }
    },
    scrollTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    dateFormat(fmt, date) {
      let ret;
      if (!date || typeof date === "string") {
        return date;
      }
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style lang="scss" scoped>
.declare {
  .main {
    padding-top: var(--window-top);
    .my-form {
      padding: 0 0.3rem;
      .input-group {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0.3rem 0.2rem;
        &.tips {
          display: block;
        }
        &.textarea {
          align-items: flex-start;
        }
        &.promise .text {
          font-size: 0.28rem;
        }
        label {
          width: 2.2rem;
          font-size: 0.32rem;
          color: #666666;
          span {
            color: #ff2424;
            margin-right: 0.1rem;
          }
        }
        input {
          width: 4.4rem;
          height: 0.64rem;
          line-height: 0.64rem;
          font-size: 0.32rem;
          border: 1px solid #dcdcdc;
          padding: 0.08rem 0.16rem;
          &::placeholder {
            font-size: 0.28rem;
            color: #a4a4a4;
          }
        }
        textarea {
          width: 4.4rem;
          height: 2rem;
          font-size: 0.28rem;
          border: 1px solid #dcdcdc;
          padding: 0.08rem 0.16rem;
          &::placeholder {
            font-size: 0.28rem;
            color: #a4a4a4;
          }
        }
        .date {
          width: 4.4rem;
          height: 0.64rem;
          line-height: 0.64rem;
          font-size: 0.32rem;
          border: 1px solid #dcdcdc;
          padding: 0 0.16rem;
        }
        .radio {
          width: 4.4rem;
        }
        button.btn {
          width: 2rem;
          height: 0.6rem;
          border-radius: 0.1rem;
        }
        .member-tips {
          font-size: 12px;
          color: #d91a27;
          margin-top: 0.2rem;
        }
        .upload-box {
          width: 4.4rem;
          display: flex;
          align-items: center;
          position: relative;
          .upload-icon {
            width: 0.6rem;
            height: 0.4rem;
            background-image: url("../../assets/images/upload-icon.png");
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: contain;
            display: block;
          }
          .upload-tips {
            font-size: 12px;
            color: #797878;
            margin-left: 0.2rem;
          }
          .upload-file {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 1;
          }
          .file-name {
            word-break: break-all;
          }
        }
      }
      .member-box {
        padding: 0.2rem 0.4rem;
        background-color: #eeeeee;
        .member-item {
          .index {
            font-size: 0.32rem;
            color: #666666;
            margin: 0;
          }
          .member-form {
            margin-left: 0.8rem;
            .member-input-group {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin: 0.2rem 0;
              label {
                width: 1.4rem;
                font-size: 0.28rem;
                color: #666666;
              }
              input {
                width: 3.4rem;
                height: 0.64rem;
                line-height: 0.64rem;
                font-size: 0.28rem;
                border: 1px solid #dcdcdc;
                padding: 0.08rem 0.16rem;
                &::placeholder {
                  font-size: 0.28rem;
                  color: #a4a4a4;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.member-input-group .radio .van-radio__icon {
  font-size: 14px;
}
.van-checkbox__label {
  color: #666666;
}
</style>